// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"d65c6e3d","267":"532313e6","592":"637de557"}[chunkId] + ".chunk.css";
};